import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGasLog } from 'redux/action/gasLog';

import MobileFooter from './mobileFooter/MobileFooter';
import MobileHeader from './mobileHeader/MobileHeader';
import { MobileMainContainer } from './MobileMain.css';
import ModuleStatusList from './ModuleStatusList';

import { moduleScnTitleMap } from 'utils/code';

const MobileMain = (props) => {
  const dispatch = useDispatch();
  const loginStatus = useSelector((store) => store.loginManager.status); // 로그인 데이터

  useEffect(() => {
    const module = props.modules.module; // 설치 및 불출 중인 장비목록
    const gasModules = module.filter((x) => x.moduleScn === moduleScnTitleMap['gas'].scn + '');
    dispatch(getGasLog(gasModules));

    const timer = window.setInterval(() => {
      dispatch(getGasLog(gasModules));
    }, Number(5000));

    return () => {
      window.clearInterval(timer);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.modules, props.auth]);

  return (
    <MobileMainContainer>
      <MobileHeader />
      {/* <MobileFooter /> */}
      <ModuleStatusList />
    </MobileMainContainer>
  );
};

export default MobileMain;
